import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { hash } = useLocation();
  const nav = useNavigate();
  const { signIn } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(hash.slice(1)).get("session_id");
    api.post("/auth/google", { session_id: sid })
      .then(({ data }) => { signIn(data); nav("/admin", { replace: true }); })
      .catch((e) => { toast.error(formatErr(e)); nav("/admin/login", { replace: true }); });
  }, [hash, nav, signIn]);

  return <div className="min-h-screen bg-[#0A0A0C]" />;
}
